export default {
  label: "Gestión de Usuarios",
};
